import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const callToActionClasses = tv({
  base: ["Call-to-action__root flex align-baseline"],
  variants: {
    spacing: {
      "8": "gap-2",
      "16": "gap-4",
      "24": "gap-8",
      "32": "gap-10",
      "48": "gap-12",
    },
    align: {
      left: "justify-start",
      right: "justify-end",
      center: "justify-center",
    },
    isResponsive: {
      true: ["sm:flex-row flex-col"],
    },
  },
});

export type CallToActionVariants = VariantProps<typeof callToActionClasses>;
